var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline select-none",class:_vm.color,attrs:{"type":_vm.type},on:{"click":_vm.clicked}},[(!_vm.loading)?_c('span',[_vm._t("default")],2):_c('DotLoading',{attrs:{"dotColor":_vm.dotColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }